export const types = {
  ADD_PERSON: 'TRANSCRIPT_ADD_PERSON',
  REMOVE_PERSON: 'TRANSCRIPT_REMOVE_PERSON',
  ADD_TAG: 'TRANSCRIPT_ADD_TAG',
  DELETE_TAG: 'TRANSCRIPT_DELETE_TAG',
  SET: {
    FIELD: 'TRANSCRIPT_SET_FIELD',
    PERSON_FIELD: 'TRANSCRIPT_SET_PERSON_FIELD',
    CALL_AUDIO: 'TRANSCRIPT_SET_CALL_AUDIO',
    LANGUAGE: 'TRSC_SET_LANGUAGE',
  },
  INSERT: {
    STARTED: 'TRANSCRIPT_INSERT_STARTED',
    FAILURE: 'TRANSCRIPT_INSERT_FAILURE',
    SUCCESS: 'TRANSCRIPT_INSERT_SUCCESS',
  },
  CHANGE_SPEAKER_NAMES: {
    STARTED: 'CHANGE_SPEAKER_NAMES_STARTED',
    FAILURE: 'CHANGE_SPEAKER_NAMES_FAILURE',
    SUCCESS: 'CHANGE_SPEAKER_NAMES_SUCCESS',
  },
};

export const addPerson = () => ({
  type: types.ADD_PERSON,
});

export const removePerson = (id) => ({
  type: types.REMOVE_PERSON,
  id,
});

export const addTag = (tag) => ({
  type: types.ADD_TAG,
  tag,
});

export const deleteTag = (tag) => ({
  type: types.DELETE_TAG,
  tag,
});

export const setField = (field, value) => ({
  type: types.SET.FIELD,
  field,
  value,
});

export const setCallAudio = (file) => ({
  type: types.SET.CALL_AUDIO,
  file,
});

export const setPersonField = (id, field, value) => ({
  type: types.SET.PERSON_FIELD,
  id,
  field,
  value,
});

export const createTranscript = (preview) => ({
  type: types.INSERT.STARTED,
  preview,
});

export const changeSpeakerNames = ({ speakers, transcriptId }) => ({
  type: types.CHANGE_SPEAKER_NAMES.STARTED,
  speakers,
  transcriptId,
});

export const changeLanguage = ({ language, languagePrefs }) => ({
  type: types.SET.LANGUAGE,
  language,
  languagePrefs,
});



// WEBPACK FOOTER //
// ./redux/actions/transcript.js